import React from "react";

const SpacerInput = ({
  children,
  gap = "5",
  className,
  xpadding = "5",
  ypadding = "5",
}) => {
  return (
    <div
      className={`w-full rounded-[21px] bg-white px-${xpadding} py-${ypadding}  flex flex-col gap-${gap}`}
    >
      {children}
    </div>
  );
};

export default SpacerInput;
